import {
  Box, Grid, TextField, Typography, Checkbox,
  TableContainer, Table, TableHead, TableCell, TableBody,
  TableRow, Button, Dialog, DialogTitle, DialogContent,
  DialogActions, Paper, FormControl, InputLabel,
  Select, MenuItem, Alert,
  Stack,
  Card,
  CardContent
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { BANK_ACCOUNTS, BankAccountItem } from "../../../constants/bankAccounts";
import { IRaffle } from "../../../store/interfaces/IRaffle";
import { BankAccount } from "../../raffle/bankAccounts";
import { banks, getIconFromBankId } from "../../../constants/banks";
import { useUpdateRaffleBankAccountsMutation } from "../../../store/api";
import { enqueueSnackbar } from "notistack";

interface BankAccountsProps {
  raffle: IRaffle
}

export const BankAccounts = ({
  raffle
}: BankAccountsProps) => {
  const initialBankAccounts = BANK_ACCOUNTS.find(
    (account) => account.accountId === raffle.accountId
  )?.bankAccounts || [];

  const [bankAccounts, setBankAccounts] = useState<BankAccountItem[]>(raffle.bankAccounts && raffle.bankAccounts.length > 0 ? raffle.bankAccounts : initialBankAccounts);
  const [openDialog, setOpenDialog] = useState(false);
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [editedAccount, setEditedAccount] = useState<BankAccountItem | null>(null);
  const [updateRaffleBankAccount, { data: updateRaffleBankAccountResponse }] = useUpdateRaffleBankAccountsMutation();

  const handleEditOpen = (index: number) => {
    setEditIndex(index);
    setEditedAccount({ ...bankAccounts[index] });
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditedAccount(null);
    setEditIndex(null);
  };

  useEffect(() => {
    if (updateRaffleBankAccountResponse) {
      enqueueSnackbar(`Se han actualizado las cuentas bancarias exitosamente`, {
        variant: "success",
        anchorOrigin: {
          horizontal: "right",
          vertical: "top"
        },
      })
    }
  }, [updateRaffleBankAccountResponse])

  const handleSaveDialog = () => {
    if (editIndex !== null && editedAccount) {
      const updatedAccounts = bankAccounts.map((acc, i) =>
        i === editIndex ? { ...editedAccount } : acc
      );
      setBankAccounts(updatedAccounts);
      const updatedAccountsAux = [] as any;
      setTimeout(() => {
        updatedAccounts.forEach(updatedAccount => {
          const a = {...updatedAccount, ticketPriceAmount: Number(updatedAccount.ticketPriceAmount), conversion: updatedAccount.conversion ? {
            dolarPrice: Number(updatedAccount.conversion.dolarPrice),
            dolarPriceCurrency: updatedAccount.conversion.dolarPriceCurrency
          }: updatedAccount.conversion}
          updatedAccountsAux.push(a)
        });

        updateRaffleBankAccount({
          raffleId: raffle.id,
          bankAccounts: updatedAccountsAux
        })
      }, 500);
    }
    handleCloseDialog();

  };

  return (
    <Box p={2}>
      {/* <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><Typography fontWeight="bold">Nombre</Typography></TableCell>
              <TableCell><Typography fontWeight="bold">Banco</Typography></TableCell>
              <TableCell><Typography fontWeight="bold">Precio del ticket</Typography></TableCell>
              <TableCell><Typography fontWeight="bold">Monto</Typography></TableCell>
              <TableCell><Typography fontWeight="bold">Moneda</Typography></TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {bankAccounts.map((account, index) => (
              <TableRow key={index}>
                <TableCell>{account.name}</TableCell>
                <TableCell>{account.bank}</TableCell>
                <TableCell>{account.ticketPrice}</TableCell>
                <TableCell>{account.ticketPriceAmount}</TableCell>
                <TableCell>{account.ticketCurrency}</TableCell>
                <TableCell>
                  <Button
                    onClick={() => handleEditOpen(index)}
                    variant="contained"
                    color="primary"
                    size="small"
                  >
                    Editar
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Alert severity="info" sx={{ mt: 2 }}>
          Para agregar o quitar cuentas bancarias comuníquese con el administrador.
        </Alert>
      </TableContainer> */}
      <Grid container>
        {  
          bankAccounts.map((bankAccount, index) => (
            <Grid xs={6} sm={6} xl={6}>
              <Button onClick={() => handleEditOpen(index)} fullWidth>
                <BankAccount item={bankAccount} ticketSelectedCount={1} templateId={"default"}></BankAccount>
              </Button>
            </Grid>
          ))
        }
      </Grid>

      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="xl">
        <DialogTitle>Editar Cuenta Bancaria</DialogTitle>
        <DialogContent>
          {editedAccount && (
            <Grid container spacing={2} p={2}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth margin="normal" disabled>
                  <InputLabel>Banco</InputLabel>
                  <Select
                    value={editedAccount.bankId}
                    onChange={(e) =>
                    {
                      const foundedBank = banks.find(bank => bank.id === e.target.value)
                      if (foundedBank) {
                        setEditedAccount({ ...editedAccount, bank: foundedBank.name, bankId: foundedBank.id })
                      }
                    }
                    }
                    label="Banco"
                  >
                    {banks.map((bank) => (
                      <MenuItem key={bank.id} value={bank.id}>
                        <Box display="flex" alignItems="center">
                          {getIconFromBankId({
                            bankId: bank.id,
                            width: 20,
                            height: 20,
                          })}
                          <Typography sx={{ pl: 1 }}>{bank.name}</Typography>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth margin="normal" disabled>
                  <InputLabel>Tipo de cuenta</InputLabel>
                  <Select
                    value={editedAccount.accountType}
                    onChange={(e) =>
                      setEditedAccount({ ...editedAccount, accountType: e.target.value })
                    }
                    label="Tipo de cuenta"
                  >
                    {[
                      "Cuenta Corriente",
                      "Cuenta RUT",
                      "Cuenta Vista",
                      "Cuenta de Ahorro",
                      "Nequi",
                      "Pago Móvil",
                    ].map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {[
                { disabled: false, field: "name", label: "Nombre" },
                { disabled: false, field: "dni", label: "DNI" },
                { disabled: false, field: "accountNumber", label: "Número de cuenta" },
                { disabled: false, field: "ticketPrice", label: "Precio (texto)" },
                { disabled: false, field: "ticketPriceAmount", label: "Precio (número)" },
                { disabled: true, field: "ticketCurrency", label: "Moneda" },
              ].map(({ disabled, field, label }) => (
                <Grid item xs={12} sm={6} key={field}>
                  <TextField
                    disabled={disabled}
                    label={label}
                    variant="outlined"
                    fullWidth
                    value={editedAccount[field as keyof BankAccountItem] || ""}
                    onChange={(e) =>
                      setEditedAccount({
                        ...editedAccount,
                        [field]: e.target.value,
                      })
                    }
                    margin="normal"
                  />
                </Grid>
              ))}

              {editedAccount.conversion && (
                <>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Precio del dólar"
                      variant="outlined"
                      fullWidth
                      value={editedAccount.conversion.dolarPrice}
                      onChange={(e) =>
                        setEditedAccount({
                          ...editedAccount,
                          conversion: {
                            ...editedAccount.conversion,
                            dolarPrice: e.target.value,
                          },
                        })
                      }
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Moneda del dólar"
                      variant="outlined"
                      fullWidth
                      value={editedAccount.conversion.dolarPriceCurrency}
                      onChange={(e) =>
                        setEditedAccount({
                          ...editedAccount,
                          conversion: {
                            ...editedAccount.conversion,
                            dolarPriceCurrency: e.target.value,
                          },
                        })
                      }
                      margin="normal"
                      type="text"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="secondary">
            Cancelar
          </Button>
          <Button onClick={handleSaveDialog} color="primary">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
